import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'active', label: 'Active' },
  { value: 'vacant', label: 'Vacant' },
  { value: 'matured', label: 'Matured' },
  { value: 'demolished', label: 'Demolished' },
  { value: 'closed', label: 'Closed' },
  { value: 'disposed', label: 'Disposed' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'asset_class', label: 'Asset Class' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'currency_code', label: 'Currency' },
  { key: 'counterparty_name', label: 'Counterparty' },
  { key: 'acquisition_date', label: 'Acquired' },
  { key: 'maturity_date', label: 'Matures' },
  { key: 'expected_return_rate', label: 'Expected Return', align: 'right', type: 'percent' },
  { key: 'status', label: 'Status' },
];

export function InvestmentRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Investment Register"
      description="Full investment listing across every asset class, with amount, dates and status."
      endpoint="/reports/investments/register"
      columns={COLUMNS}
      filters={['status', 'category', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      categoryOptions={listOptions(lists, 'investment_asset_class')}
      listColumns={{ asset_class: 'investment_asset_class' }}
      defaultSort="name"
      xlsx
    />
  );
}
